<template>
    <div class="container-fluid  pt-2">
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <h5>Purchase Orders</h5>
            </div>
            <div class="col-md-6 col-sm-12">
             </div>
        </div>
        <hr />
        <div class="row text-center">
            <div class="col-md-4 col-sm-4 border-right border-dark">
                <h5>{{ purchasesCount }}</h5>
                <p>Purchases</p>
            </div>
            <div class="col-md-4 col-sm-4 border-right border-dark">
                <h5>{{ convertCurrencyToShillings(totalAmountOfPurchases) }}</h5>
                <p>Amount Spent</p>
                <hr />
                 <h5 class="text-danger">{{ convertCurrencyToShillings(totalPendingBalances) }}</h5>
                <p>Amount you owe</p>
             </div>
            <div class="col-md-4 col-sm-4 border-right ">
                <h5>{{ purchasesCount }}</h5>
                <p>Suppliers - <a href="/suppliers">View all</a></p>
             </div>
        </div>
        <hr />

        <div class="row py-1">
            <div class="col-md-4 col-sm-12 py-1">
                <form>
                    <div class="input-group w-100 my-1">
                        <input type="text" class="form-control" v-model="searchItem" placeholder="Search Purchase enter order">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="submit">
                                        <i class="fa fa-search"></i>
                                    </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-4 col-sm-12 py-1">
                <form>
                    <div class="input-group w-100 my-1">

                        <select v-model="selectedSupplier" class="form-control" v-if="suppliers">
                            <option value="null">Select Supplier</option>
                            <option v-if="supplier.supplier !==null" v-for="supplier in suppliers" :value="supplier.id">
                                {{ supplier.supplier }}
                            </option>
                        </select>
                    </div>
                </form>
            </div>

            <div class="col-md-4 col-sm-12 py-2">

                <date-range-picker :auto-apply="autoApply" v-model="dateRange" :ranges="ranges" :opens="datepicker_opens" :append-to-body="append_to_body" class="custom-width-datepicker pb-2">
                            <template #input="picker" style="width: 100% !important;">
                                                        <p v-if="picker.startDate !==null && picker.endDate !==null">{{ formatDate(picker.startDate,'DD-MMM-YYYY') }} - {{ formatDate(picker.endDate,'DD-MMM-YYYY') }}</p>
                                                        <p v-else><i class="bi bi-calendar-event"></i>  Filter by Date</p>
                            </template>
                                            </date-range-picker>
            </div>
        </div>
        <div style="margin-bottom: 5em;">
            <b-table
                striped class="text-primary"
                hover
                small
                sticky-header="100vh"
                :items="purchaseOrdersFiltered"
                :fields="fields"
                sort-icon-left
                responsive="sm"
                @row-clicked="rowSelected"
            >
            <template #cell(created_at)="data">
                <p>{{ formatDate(data.item.created_at,'hh:mm A DD-MM-Y') }}</p>
            </template>
            <template #cell(supplier)="data">
                <p v-if="data.item.supplier">{{ data.item.supplier.supplier }} - {{ data.item.supplier.phone }}</p>
            </template>

            </b-table>
        </div>
        <b-modal ref="orderDetailsModal" size="lg" hide-footer>

            <div class="text-left" v-if="orderToShow">
                    <h6 class="py-1">Order No:  &nbsp; {{orderToShow.purchase_order}}</h6>

                    <h6 v-if="orderToShow.total_amount" class="py-2">Order Amount:  &nbsp; {{convertCurrencyToShillings(orderToShow.total_amount)}}</h6>
                    <h6 v-if="orderToShow.receipt" class="">Receipt:  &nbsp; {{orderToShow.receipt}}</h6>
                    <p class="py-1">Time:&nbsp; <span class="">{{formatDate(orderToShow.created_at,'hh:mm A')}}</span></p>
                    <p class="py-1">Date:&nbsp; <span class="">{{formatDate(orderToShow.created_at,'DD-MMM-YYYY')}}</span></p>
                    <p v-if="orderToShow.purchasedby" class="py-1">Received by:&nbsp  <span class="text-capitalize">{{orderToShow.purchasedby.full_name ? orderToShow.purchasedby.full_name : orderToShow.purchasedby.name}}</span></p>

                    <div class="text-left" v-if="orderToShow.supplier">
                    <p v-if="orderToShow.supplier" class="py-1">Supplier:&nbsp; <span class="font-weight-bold"></span>&nbsp;{{orderToShow.supplier.supplier}}<a class="text-primary" :href="`/suppliers?id=${orderToShow.supplier.id}`" > | View</a> </p>
                    <p v-if="orderToShow.supplier" class="py-1">Supplier phone:&nbsp; <span class="font-weight-bold"></span>&nbsp;{{orderToShow.supplier.phone}} </p>
                    <p v-if="orderToShow.supplier" class="py-1">Supplier email:&nbsp; <span class="font-weight-bold"></span>&nbsp;{{orderToShow.supplier.email}} </p>
                    <!-- <p v-if="orderToShow.supplier" class="py-1">Supplier rep:&nbsp; <span class="font-weight-bold"></span>&nbsp;{{customer.email}} </p> -->
                    </div>
                    </div>
                   <hr/>
                <div class="text-left">
                    <h5>
                        Purchase order list
                    </h5>
                </div>
                <div class="text-left d-inline py-2" >
                  <a v-if="canDeletePurchases" v-b-modal="'verify-po-delete-b4-submit'" class="btn btn-sm btn-danger">Delete Purchase</a>
                     <a v-if="canViewPurchases"
                        class="btn btn-sm btn-outline-primary"
                        @click="printGRN">
                        Print GRN
                    </a>
                </div>
                <div class="table-responsive">
                <table class="table table-hover">
                    <thead>

                        <td>#</td>
                        <td>Item</td>
                        <td>Qty</td>
                        <td>Amount</td>
                        <td>Total</td>
                    </thead>
                    <tbody>
                        <tr v-if="purchaseItems"  v-for="logs in purchaseItems">
                        <td>#</td>
                        <td v-if="logs.products">{{ logs.products.product }}</td>
                        <td>{{ logs.new_quantity}}</td>
                        <td>{{ convertCurrencyToLocal((logs.new_buying_price)?logs.new_buying_price:logs.products.wholesale_ppu )}}</td>
                        <td>{{ convertCurrencyToLocal((logs.new_quantity) * ((logs.new_buying_price)?logs.new_buying_price:logs.products.wholesale_ppu)) }}</td>
                        </tr>
                    </tbody>

                    </table>
                </div>
                    <div class="container" v-if="purchaseDetails.media ">
                        <h5>Files</h5>
                        <hr />
                       <ul>
                        <li v-for="file in purchaseDetails.media" :key="file.id">

                            <!-- Check if the file is a PDF -->
                            <template v-if="file.mime_type.startsWith('image/')">

                                <img :src="file.original_url" alt="File Preview" style="max-width: 100px; max-height: 100px;">
                            </template>
                            <p>   <span>{{ file.file_name }}</span> <a :href="file.original_url" :download="file.file_name"><span class="px-1 h4"><i class="bi bi-download"></i></span></a></p>

                        </li>
                       </ul>
                    </div>




           </b-modal>
           <b-modal id="verify-po-delete-b4-submit" hide-footer>
            <div class="text-center">
                <div class="py-4">
                    <p>Are you sure you want to delete {{ orderToShow.purchase_order}}?</p>

                    <a @click="confirmPODelete"
                        class="btn btn-primary"
                        :class="{ 'disabled': !confirmIsNotComplete }"
                        :disabled="!confirmIsNotComplete">
                        Yes! Delete
                        </a>

                </div>
            </div>
        </b-modal>
   </div>


</template>

<script>
     import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import {mapGetters} from 'vuex'
    export default {
        name: 'products',
        components: {
            DateRangePicker
        },
        data() {
            return {

                editprodform: {
                    title: '',
                    ppu: '',
                    wholesale_sp: '',
                    measuring: '',
                    product_id: '',
                    remaining_units: '',
                    wholesale_ppu: ''
                },
                confirmIsNotComplete:true,
                groupItems:{
                    group_title:'',
                    cost:'',
                    wholesale:'',
                    groupItemsArray:[],

                },
                inventoryItemsDetails:{
                    searchTerm: '',
                    searchTable: false,
                    filteredInventoryItems: {},
                    selectedInventoryItem: {},
                    product: {}
                },

                fields: [{
                        key: "purchase_order",
                        sortable: true,
                        label:"Purchase Order"
                    },
                    {
                        key: "total_amount",
                        sortable: true,
                        label:"Amount"
                    },
                    {
                        key: "balance",
                        sortable: true,
                        label:"Balance"
                    },
                    {
                        key: "supplier",
                        sortable: true,
                        label:"Supplier"
                    },
                    {
                        key: "created_at",
                        sortable: true,
                        label:"Date"
                    }

                ],
                purchaseOrders:[],
                dateRange: {
                    startDate: null,
                    endDate: null,
                },
                selectedSupplier:null,
                autoApply: true,
                append_to_body: true,
                datepicker_opens: 'right',
                ranges: false,

                userRole: '',

                companySettings: '',
                searchItem: '',
                items: [],
                totalAmountOfPurchases: 0,
                totalPendingBalances: 0,

                selectedProduct: {
                    allOtherItems:{
                        grouped_items:[],
                    },
                },
                purchasesCount:'',
                purchaseItems:'',
                purchaseDetails:'',
                supplierCount:'',
                suppliers:{},
                orderToShow:{}
            }

        },
        computed:{
            isAdminOrOwner() {
                return ((this.userDetails && this.userDetails.roles) || []).some(r => r.name === 'Admin' || r.name === 'owner');
            },
            // Same rules as PurchaseController::destroy / show.
            canDeletePurchases() {
                return this.isAdminOrOwner || this.hasPermission('can manage suppliers') || this.hasPermission('can manage inventory');
            },
            canViewPurchases() {
                return this.canDeletePurchases || this.hasPermission('view-purchases') || this.hasPermission('can receive stock');
            },
            ...mapGetters(['userDetails']),
            purchaseOrdersFiltered() {
                    return this.purchaseOrders.filter(item => {
                        const purchaseOrder = item.purchase_order ? item.purchase_order.toLowerCase() : '';
                        const supplier = item.supplier ? item.supplier.supplier.toLowerCase() : '';
                        return purchaseOrder.includes(this.searchItem.toLowerCase()) || supplier.includes(this.searchItem.toLowerCase());
                    });
            },
        },



        watch: {
            dateRange: {
                deep: true,
                handler(after, before) {
                    if (after.startDate && after.endDate) {
                        const urlParams = new URLSearchParams(window.location.search);
                        const startDateString = after.startDate.toISOString().split('T')[0]; // Convert to ISO format without time
                        const endDateString = after.endDate.toISOString().split('T')[0]; // Convert to ISO format without time

                        urlParams.set('start-date', startDateString);
                        urlParams.set('end-date', endDateString);

                        window.history.replaceState(null, null, '?' + urlParams.toString());
                     }
                    this.getPurchases()
                }

            },
            selectedSupplier:{
                handler(after,before){

                        const urlParams = new URLSearchParams(window.location.search);

                        urlParams.set('supplier', this.selectedSupplier);


                        window.history.replaceState(null, null, '?' + urlParams.toString());

                    this.getPurchases()

                }
            }
        },


        mounted() {

            this.getPurchases()

            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('purchase-id')) {
                this.viewPurchaseById(urlParams.get('purchase-id'));
            }

        },
        methods: {
           async getPurchases() {
                const urlParams = new URLSearchParams(window.location.search);
               await axios.get('/api/purchases',{params:{
                    startdate: urlParams.get('start-date'),
                    enddate: urlParams.get('end-date'),
                    supplier_id: urlParams.get('supplier'),

                 }})
                    .then(results => {
                        this.purchaseOrders = results.data.purchases.data
                        this.suppliers = results.data.supplierList
                        this.totalAmountOfPurchases = results.data.sum
                        this.totalPendingBalances = results.data.balances
                        this.purchasesCount = results.data.count
                        this.supplierCount = results.data.suppliers
                    }).catch(errors => {});
            },
            printGRN() {
                if (!this.orderToShow || !this.orderToShow.id) return;
                // Server-rendered PDF, same design as invoices and quotes.
                window.open(`/api/purchases/${this.orderToShow.id}/grn`, '_blank');
            },
            confirmPODelete() {

                this.confirmIsNotComplete=false
                   axios.delete('/api/purchases/' + this.orderToShow.id).then(results=>{
                    if(results.status === 200)
                    {
                        this.confirmIsNotComplete=true
                        window.location.reload()

                    }
                   })

            },

            hasPermission(permissionName) {
                 return (this.userDetails?.permissions || []).some(permission => permission.name === permissionName);
            },
            createGroupItem(){
                axios.post('/api/group-item',{...this.groupItems}).then(
                    results=>{
                        if(results.status===200)
                        {
                            window.location.reload()
                        }
                    }
                ).catch()
            },
            getProducts() {
                axios.get('/api/all-items-and-count').then(results => {
                    this.inventoryItemsDetails.product = results.data.items
                    // console.log(results.data.items)
                }).catch(error => {})
            },
              getPurchase(id) {
                axios.get(`/api/purchases/${id}`).then(results => {
                    this.purchaseDetails = results.data
                    this.purchaseItems = results.data.restock_logs

                }).catch(error => {})
            },
            productSelected(item){
                this.groupItems.groupItemsArray.push(item)
                this.inventoryItemsDetails.filteredInventoryItems=[]
                console.log(this.groupItems.groupItemsArray)
            },
            searchInventoryItem() {
                const searchTerm = this.inventoryItemsDetails.searchTerm.toLowerCase();
                this.inventoryItemsDetails.filteredInventoryItems = this.inventoryItemsDetails.product.filter(product =>
                    (product.product && product.product.toLowerCase().includes(searchTerm))

                );

            },

            rowSelected(items) {


                this.orderToShow = items

                this.getPurchase(items.id)

                this.$refs.orderDetailsModal.show();

            },

            // Deep link from the Ledger's "open full purchase" link — unlike
            // rowSelected, this purchase may not be in the currently loaded
            // (paginated) list, so fetch it directly instead of looking it up.
            viewPurchaseById(id) {
                axios.get(`/api/purchases/${id}`).then(results => {
                    this.orderToShow = results.data
                    this.purchaseDetails = results.data
                    this.purchaseItems = results.data.restock_logs
                    this.$refs.orderDetailsModal.show();
                }).catch(() => {})
            },


            searchQueryItems() {
                this.getProducts();
            },
            formatDate(date, format) {
                return moment(date).format(format);
            },


    }
}
</script>


